export const ChargeEventStatusForAPI = {
    PAID: 'paid',
    SCHEDULED: 'scheduled',
    UNPAID: 'unpaid',
    REFUNDED: 'refunded',
    PARTIALLY_REFUNDED: 'partially_refunded',
    STRIPE_PENDING: 'stripe_pending',
    FAILED: 'failed',
}
